export const indianStates = [
  // States
  'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
  'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand',
  'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur',
  'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab',
  'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura',
  'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
  // Union Territories
  'Andaman and Nicobar Islands', 'Chandigarh', 'Dadra and Nagar Haveli and Daman and Diu',
  'Delhi', 'Jammu and Kashmir', 'Ladakh', 'Lakshadweep', 'Puducherry'
];

export const governmentHospitals = {
  'Maharashtra': [
    'KEM Hospital, Mumbai',
    'Sion Hospital, Mumbai',
    'JJ Hospital, Mumbai',
    'Nair Hospital, Mumbai',
    'LTMG Hospital, Sion',
    'Rajawadi Hospital, Ghatkopar',
    'Sassoon Hospital, Pune',
    'Government Medical College, Nagpur'
  ],
  'Delhi': [
    'AIIMS Delhi',
    'Safdarjung Hospital',
    'Ram Manohar Lohia Hospital',
    'GTB Hospital',
    'DDU Hospital',
    'Lok Nayak Hospital',
    'Lady Hardinge Medical College'
  ],
  'Karnataka': [
    'Victoria Hospital, Bangalore',
    'Bowring & Lady Curzon Hospital, Bangalore',
    'KC General Hospital, Bangalore',
    'Vani Vilas Hospital, Bangalore',
    'District Hospital, Mysore'
  ],
  'Tamil Nadu': [
    'Government General Hospital, Chennai',
    'Stanley Medical College, Chennai',
    'Rajiv Gandhi Government Hospital, Chennai',
    'Kilpauk Medical College, Chennai'
  ],
  'Gujarat': [
    'Civil Hospital, Ahmedabad',
    'BJ Medical College, Ahmedabad',
    'SSG Hospital, Vadodara'
  ],
  'Uttar Pradesh': [
    'King George Medical University, Lucknow',
    'District Hospital, Noida',
    'District Hospital, Agra'
  ],
  'West Bengal': [
    'SSKM Hospital, Kolkata',
    'R G Kar Medical College, Kolkata',
    'Medical College Hospital, Kolkata'
  ],
  'Rajasthan': [
    'SMS Hospital, Jaipur',
    'JLN Hospital, Ajmer'
  ],
  'Telangana': [
    'Gandhi Hospital, Hyderabad',
    'Osmania General Hospital, Hyderabad',
    'Niloufer Hospital, Hyderabad'
  ],
  'Kerala': [
    'Medical College Hospital, Thiruvananthapuram',
    'Medical College Hospital, Kottayam',
    'District Hospital, Ernakulam'
  ],
  'Andhra Pradesh': [
    'Government General Hospital, Vijayawada',
    'King George Hospital, Visakhapatnam',
    'RIMS Hospital, Ongole'
  ],
  'Arunachal Pradesh': [
    'Tomo Riba Institute, Naharlagun',
    'District Hospital, Itanagar'
  ],
  'Assam': [
    'Gauhati Medical College, Guwahati',
    'Silchar Medical College, Silchar'
  ],
  'Bihar': [
    'Patna Medical College, Patna',
    'Darbhanga Medical College, Darbhanga',
    'Nalanda Medical College, Patna'
  ],
  'Chhattisgarh': [
    'Dr. Bhim Rao Ambedkar Hospital, Raipur',
    'Government Medical College, Bilaspur'
  ],
  'Goa': [
    'Goa Medical College, Bambolim',
    'District Hospital, Margao'
  ],
  'Haryana': [
    'PGIMS, Rohtak',
    'Civil Hospital, Gurugram',
    'General Hospital, Faridabad'
  ],
  'Himachal Pradesh': [
    'IGMC, Shimla',
    'Dr. Rajendra Prasad Medical College, Tanda'
  ],
  'Jharkhand': [
    'RIMS, Ranchi',
    'MGM Medical College, Jamshedpur'
  ],
  'Madhya Pradesh': [
    'Gandhi Medical College, Bhopal',
    'MGM Medical College, Indore'
  ],
  'Manipur': [
    'JNIMS, Imphal',
    'Regional Institute, Imphal'
  ],
  'Meghalaya': [
    'NEIGRIHMS, Shillong',
    'Civil Hospital, Shillong'
  ],
  'Mizoram': [
    'Civil Hospital, Aizawl',
    'Zoram Medical College, Falkawn'
  ],
  'Nagaland': [
    'District Hospital, Kohima',
    'Christian Hospital, Kohima'
  ],
  'Odisha': [
    'SCB Medical College, Cuttack',
    'MKCG Medical College, Berhampur'
  ],
  'Punjab': [
    'Government Medical College, Amritsar',
    'Government Medical College, Patiala',
    'PGIMER, Chandigarh'
  ],
  'Sikkim': [
    'STNM Hospital, Gangtok',
    'District Hospital, Namchi'
  ],
  'Tripura': [
    'GB Pant Hospital, Agartala',
    'Agartala Government Medical College'
  ],
  'Uttarakhand': [
    'Base Hospital, Dehradun',
    'Government Medical College, Haldwani'
  ],
  'Andaman and Nicobar Islands': [
    'GB Pant Hospital, Port Blair'
  ],
  'Chandigarh': [
    'PGIMER, Chandigarh',
    'Government Multi Speciality Hospital, Sector 16'
  ],
  'Dadra and Nagar Haveli and Daman and Diu': [
    'Community Health Centre, Silvassa',
    'District Hospital, Daman'
  ],
  'Jammu and Kashmir': [
    'Government Medical College, Srinagar',
    'Government Medical College, Jammu'
  ],
  'Ladakh': [
    'SNM Hospital, Leh',
    'District Hospital, Kargil'
  ],
  'Lakshadweep': [
    'Primary Health Centre, Kavaratti'
  ],
  'Puducherry': [
    'JIPMER, Puducherry',
    'Indira Gandhi Government Hospital'
  ]
};

export const privateHospitals = {
  'Maharashtra': [
    'Apollo Hospital, Mumbai',
    'Fortis Hospital, Mumbai',
    'Lilavati Hospital, Mumbai',
    'Breach Candy Hospital, Mumbai',
    'Hinduja Hospital, Mumbai',
    'Nanavati Hospital, Mumbai',
    'Ruby Hall Clinic, Pune',
    'Jupiter Hospital, Pune'
  ],
  'Delhi': [
    'Max Hospital, Saket',
    'Fortis Hospital, Vasant Kunj',
    'Apollo Hospital, Sarita Vihar',
    'Medanta Hospital, Gurugram',
    'Artemis Hospital, Gurugram',
    'BLK Hospital, Delhi'
  ],
  'Karnataka': [
    'Manipal Hospital, Bangalore',
    'Columbia Asia Hospital, Bangalore',
    'Fortis Hospital, Bangalore',
    'Apollo Hospital, Bangalore',
    'Sakra World Hospital, Bangalore'
  ],
  'Tamil Nadu': [
    'Apollo Hospital, Chennai',
    'Fortis Malar Hospital, Chennai',
    'MIOT Hospital, Chennai',
    'Kauvery Hospital, Chennai'
  ],
  'Gujarat': [
    'Sterling Hospital, Ahmedabad',
    'Apollo Hospital, Ahmedabad',
    'Zydus Hospital, Ahmedabad'
  ],
  'Uttar Pradesh': [
    'Max Hospital, Noida',
    'Fortis Hospital, Noida',
    'Jaypee Hospital, Noida'
  ],
  'West Bengal': [
    'Apollo Gleneagles Hospital, Kolkata',
    'Fortis Hospital, Kolkata',
    'AMRI Hospital, Kolkata'
  ],
  'Rajasthan': [
    'Fortis Hospital, Jaipur',
    'Eternal Hospital, Jaipur',
    'Manipal Hospital, Jaipur'
  ],
  'Telangana': [
    'Apollo Hospital, Hyderabad',
    'Yashoda Hospital, Hyderabad',
    'KIMS Hospital, Hyderabad',
    'Care Hospital, Hyderabad'
  ],
  'Kerala': [
    'Amrita Hospital, Kochi',
    'Aster Medcity, Kochi',
    'KIMS Hospital, Trivandrum'
  ]
};

export const privateClinics = {
  'Maharashtra': [
    'Dr. Mehta Clinic, Bandra',
    'City Health Clinic, Andheri',
    'MediCare Center, Thane',
    'Prime Health Clinic, Pune',
    'Wellness Clinic, Powai'
  ],
  'Delhi': [
    'Dr. Sharma Clinic, Connaught Place',
    'Health First Clinic, Dwarka',
    'MediPlus Clinic, Rohini',
    'Care Clinic, Lajpat Nagar'
  ],
  'Karnataka': [
    'Dr. Rao Clinic, Indiranagar',
    'Family Care Clinic, Koramangala',
    'Health Hub, Whitefield',
    'MediCare Clinic, Jayanagar'
  ],
  'Tamil Nadu': [
    'Dr. Krishna Clinic, T Nagar',
    'Health Point, Adyar',
    'Care Plus Clinic, Velachery'
  ],
  'Gujarat': [
    'Dr. Patel Clinic, Satellite',
    'Health Center, Maninagar',
    'MediCare, CG Road'
  ],
  'Uttar Pradesh': [
    'Dr. Singh Clinic, Sector 18',
    'Health Care Center, Greater Noida',
    'Family Clinic, Indirapuram'
  ],
  'West Bengal': [
    'Dr. Banerjee Clinic, Salt Lake',
    'Health Plus, Park Street',
    'Care Clinic, Ballygunge'
  ],
  'Rajasthan': [
    'Dr. Sharma Clinic, Vaishali Nagar',
    'Health Point, Civil Lines',
    'MediCare, Malviya Nagar'
  ],
  'Telangana': [
    'Dr. Reddy Clinic, Banjara Hills',
    'Health Center, Madhapur',
    'Family Clinic, Kukatpally'
  ],
  'Kerala': [
    'Dr. Nair Clinic, MG Road',
    'Health Point, Kaloor',
    'Care Clinic, Palarivattom'
  ]
};
// Adding remaining states to private hospitals
const additionalPrivateHospitals = {
  'Andhra Pradesh': ['Apollo Hospital, Vijayawada', 'Ramesh Hospitals, Guntur'],
  'Assam': ['Down Town Hospital, Guwahati', 'Nemcare Hospital, Guwahati'],
  'Bihar': ['Paras HMRI Hospital, Patna', 'Ruban Memorial Hospital, Patna'],
  'Chhattisgarh': ['Apollo Hospital, Bilaspur', 'Shri Narayana Hospital, Raipur'],
  'Goa': ['Manipal Hospital, Goa', 'Apollo Victor Hospital, Goa'],
  'Haryana': ['Fortis Memorial, Gurugram', 'Artemis Hospital, Gurugram'],
  'Himachal Pradesh': ['Indus Hospital, Dehradun', 'Max Hospital, Dehradun'],
  'Jharkhand': ['Tata Main Hospital, Jamshedpur', 'Medica Hospital, Ranchi'],
  'Madhya Pradesh': ['Apollo Hospital, Indore', 'CHL Hospital, Indore'],
  'Punjab': ['Fortis Hospital, Mohali', 'Ivy Hospital, Mohali'],
  'Uttarakhand': ['Max Hospital, Dehradun', 'Synergy Hospital, Dehradun']
};

Object.assign(privateHospitals, additionalPrivateHospitals);

// Adding remaining states to private clinics
const additionalPrivateClinics = {
  'Andhra Pradesh': ['Dr. Rao Clinic, Vijayawada', 'Care Clinic, Visakhapatnam'],
  'Assam': ['Health Point, Guwahati', 'Dr. Das Clinic, Dibrugarh'],
  'Bihar': ['Dr. Kumar Clinic, Patna', 'Family Health, Gaya'],
  'Haryana': ['MediCare Clinic, Gurugram', 'Dr. Sharma Clinic, Faridabad'],
  'Punjab': ['Dr. Singh Clinic, Ludhiana', 'Health Center, Amritsar']
};

Object.assign(privateClinics, additionalPrivateClinics);

// Complete data for all additional states and UTs

// Add to privateHospitals
Object.assign(privateHospitals, {
  'Andhra Pradesh': ['Apollo Hospital, Vijayawada', 'Ramesh Hospitals, Guntur', 'Manipal Hospital, Visakhapatnam'],
  'Arunachal Pradesh': ['General Hospital, Itanagar', 'District Hospital, Naharlagun'],
  'Assam': ['Down Town Hospital, Guwahati', 'Nemcare Hospital, Guwahati', 'Hayat Hospital, Guwahati'],
  'Bihar': ['Paras HMRI Hospital, Patna', 'Ruban Memorial Hospital, Patna', 'Ford Hospital, Patna'],
  'Chhattisgarh': ['Apollo Hospital, Bilaspur', 'Shri Narayana Hospital, Raipur', 'Ramkrishna Care Hospital, Raipur'],
  'Goa': ['Manipal Hospital, Goa', 'Apollo Victor Hospital, Goa', 'Healthway Hospital, Goa'],
  'Haryana': ['Fortis Memorial, Gurugram', 'Artemis Hospital, Gurugram', 'Paras Hospital, Gurugram'],
  'Himachal Pradesh': ['Indus Hospital, Dehradun', 'Max Hospital, Dehradun', 'Fortis Hospital, Mohali'],
  'Jharkhand': ['Tata Main Hospital, Jamshedpur', 'Medica Hospital, Ranchi', 'Bokaro General Hospital, Bokaro'],
  'Madhya Pradesh': ['Apollo Hospital, Indore', 'CHL Hospital, Indore', 'Bombay Hospital, Indore'],
  'Manipur': ['City Hospital, Imphal', 'Shija Hospital, Imphal'],
  'Meghalaya': ['Woodland Hospital, Shillong', 'Bethany Hospital, Shillong'],
  'Mizoram': ['Synod Hospital, Aizawl', 'Civil Hospital, Aizawl'],
  'Nagaland': ['Christian Institute Hospital, Dimapur', 'Naga Hospital, Kohima'],
  'Odisha': ['Apollo Hospital, Bhubaneswar', 'Sum Hospital, Bhubaneswar', 'Kalinga Hospital, Bhubaneswar'],
  'Punjab': ['Fortis Hospital, Mohali', 'Ivy Hospital, Mohali', 'Max Hospital, Mohali'],
  'Sikkim': ['STNM Hospital, Gangtok', 'Central Referral Hospital, Gangtok'],
  'Tripura': ['IGM Hospital, Agartala', 'Prashanti Hospital, Agartala'],
  'Uttarakhand': ['Max Hospital, Dehradun', 'Synergy Hospital, Dehradun', 'Doon Hospital, Dehradun'],
  'Andaman and Nicobar Islands': ['GB Pant Hospital, Port Blair'],
  'Chandigarh': ['PGIMER, Chandigarh', 'Fortis Hospital, Mohali'],
  'Dadra and Nagar Haveli and Daman and Diu': ['Community Health Centre, Silvassa', 'District Hospital, Daman'],
  'Jammu and Kashmir': ['Fortis Hospital, Srinagar', 'Shri Maharaja Hari Singh Hospital, Srinagar'],
  'Ladakh': ['SNM Hospital, Leh'],
  'Lakshadweep': ['Primary Health Centre, Kavaratti'],
  'Puducherry': ['JIPMER, Puducherry', 'Mahatma Gandhi Medical College, Puducherry']
});

// Add to privateClinics
Object.assign(privateClinics, {
  'Andhra Pradesh': ['Dr. Rao Clinic, Vijayawada', 'Care Clinic, Visakhapatnam', 'Health Point, Guntur'],
  'Arunachal Pradesh': ['Dr. Singh Clinic, Itanagar', 'Medical Center, Naharlagun'],
  'Assam': ['Health Point, Guwahati', 'Dr. Das Clinic, Dibrugarh', 'Care Clinic, Silchar'],
  'Bihar': ['Dr. Kumar Clinic, Patna', 'Family Health, Gaya', 'Health Center, Muzaffarpur'],
  'Chhattisgarh': ['Dr. Sharma Clinic, Raipur', 'Medical Center, Bilaspur'],
  'Goa': ['Dr. D Silva Clinic, Panaji', 'Health Point, Margao'],
  'Haryana': ['MediCare Clinic, Gurugram', 'Dr. Sharma Clinic, Faridabad', 'Health Center, Ambala'],
  'Himachal Pradesh': ['Dr. Verma Clinic, Shimla', 'Health Point, Dharamshala'],
  'Jharkhand': ['Dr. Singh Clinic, Ranchi', 'Health Center, Jamshedpur'],
  'Madhya Pradesh': ['Dr. Patel Clinic, Indore', 'Health Point, Bhopal', 'Care Clinic, Jabalpur'],
  'Manipur': ['Dr. Singh Clinic, Imphal'],
  'Meghalaya': ['Dr. Khongwir Clinic, Shillong'],
  'Mizoram': ['Health Center, Aizawl'],
  'Nagaland': ['Dr. Yaden Clinic, Kohima'],
  'Odisha': ['Dr. Panda Clinic, Bhubaneswar', 'Health Point, Cuttack'],
  'Punjab': ['Dr. Singh Clinic, Ludhiana', 'Health Center, Amritsar', 'Care Clinic, Jalandhar'],
  'Sikkim': ['Dr. Lepcha Clinic, Gangtok'],
  'Tripura': ['Dr. Debbarma Clinic, Agartala'],
  'Uttarakhand': ['Dr. Rawat Clinic, Dehradun', 'Health Point, Haridwar'],
  'Andaman and Nicobar Islands': ['Health Center, Port Blair'],
  'Chandigarh': ['Dr. Gupta Clinic, Sector 17', 'Medical Center, Sector 22'],
  'Dadra and Nagar Haveli and Daman and Diu': ['Health Center, Silvassa'],
  'Jammu and Kashmir': ['Dr. Malik Clinic, Srinagar', 'Health Point, Jammu'],
  'Ladakh': ['Medical Center, Leh'],
  'Lakshadweep': ['Health Center, Kavaratti'],
  'Puducherry': ['Dr. Kumar Clinic, White Town', 'Health Point, Pondicherry']
});
